export default "__VITE_ASSET__BE6D$WFU__"